import { useEffect, useRef, useState } from "react";

// Count-up animation from 0 -> target with easeOutCubic over `duration` ms.
// Starts only when `active` becomes true.
export default function useCountUp(target, active, duration = 1200) {
  const [value, setValue] = useState(0);
  const frame = useRef(null);
  const startTs = useRef(null);

  useEffect(() => {
    if (!active) {
      setValue(0);
      return undefined;
    }

    const prefersReduced =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReduced) {
      setValue(target);
      return undefined;
    }

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    const tick = (ts) => {
      if (startTs.current === null) startTs.current = ts;
      const elapsed = ts - startTs.current;
      const progress = Math.min(elapsed / duration, 1);
      setValue(Math.round(easeOutCubic(progress) * target));
      if (progress < 1) {
        frame.current = requestAnimationFrame(tick);
      }
    };

    frame.current = requestAnimationFrame(tick);
    return () => {
      if (frame.current) cancelAnimationFrame(frame.current);
      startTs.current = null;
    };
  }, [target, active, duration]);

  return value;
}
